module.exports = __webpack_public_path__ + "img/sa.a0d4d9d.webp";